// extracted by css-extract-rspack-plugin
export default {"paidFeatureGate":"wbEgRsmeX3oc7yWe","paidPillWrapper":"XeWIIp5365o2nP8P"};